(function() {
	'use strict';

	angular.module('app.dashboard')
	.service('leanProjectSummaryService', leanProjectSummaryService);

	function leanProjectSummaryService($http, hostUrl) {
		var baseUrl = hostUrl + '2/factndx/';
		return {
			getSummaryData: getSummaryData,
			getArchiveStageIds: getArchiveStageIds
		};

		function getSummaryData(filterService) {
			var url = baseUrl;
			url += filterService.getFactoryList();
			url += '/Projects/Summary';
			var filterQueryParams = filterService.getQueryParamsObject(true);
			filterQueryParams['includeArchived'] = true;
			url = addQueryParam(url, filterService.getFactoryList(), filterQueryParams, false);

			return $http.get(url)
				.then(getSummaryDataComplete)
				.catch(getSummaryDataFailed);

			function getSummaryDataComplete(response) {
				return response.data;
			}
			function getSummaryDataFailed(error) {
				return error;
			}
		}
		function getArchiveStageIds(stageFilter) {
			if (stageFilter) {
				var archivedStage = _.find(stageFilter, function (o) { return o.stageSequence === 1000; });
				if (archivedStage) {
					return archivedStage['id'];
				}
			}
			return [];
		}
	}
})();
